import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Store01FreeIcons } from '@hugeicons/core-free-icons';

interface RoleSwitchDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RoleSwitchDialog({ isOpen, onClose, onConfirm }: RoleSwitchDialogProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const dialogContent = (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-2xl p-6 mx-4 max-w-sm w-full">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <HugeiconsIcon
            icon={Store01FreeIcons}
            size={36}
            strokeWidth={2}
            className="text-blue-700"
          />
        </div>
        <h3 className="text-lg font-semibold mb-4 text-center">
          {t('switch_to_merchant_role_title', 'Do you want to switch to Merchant role?')}
        </h3>
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-colors"
          >
            {t('no', 'No')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 px-4 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-colors"
          >
            {t('yes', 'Yes')}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(dialogContent, document.body);
}
